import { Link as GatsbyLink } from 'gatsby';
import * as React from 'react';
export default {
  GatsbyLink,
  React
};